let cfOrigin = "";

if (process.env.GATSBY_CF_DOMAIN) {
  cfOrigin = "https://cf.onlineboatshow.jp";
}

console.log("GATSBY_CF_DOMAI:", process.env.GATSBY_CF_DOMAIN);

console.log("cfOrigin:", cfOrigin);

export { cfOrigin };
